export const FETCH_FAILED_REDEMPTIONS = "support/fetchFailedRedemptions";
export const FETCH_FAILED_REDEMPTIONS_START = "support/fetchFailedRedemptionsStart";
export const FETCH_FAILED_REDEMPTIONS_COMPLETE = "support/fetchFailedRedemptionsCompleted";
export const FETCH_FAILED_REDEMPTIONS_ERROR = "support/fetchFailedRedemptionsError";

export const fetchFailedRedemptions = (payload = {}) => ({
  type: FETCH_FAILED_REDEMPTIONS,
  payload,
});

export const BATCH_RETRY_REDEEM_REWARD = "support/batchRetryRedeemReward";
export const BATCH_RETRY_REDEEM_REWARD_START = "support/batchRetryRedeemRewardStart";
export const BATCH_RETRY_REDEEM_REWARD_PROGRESS = "support/batchRetryRedeemRewardProgress";
export const BATCH_RETRY_REDEEM_REWARD_COMPLETE = "support/batchRetryRedeemRewardCompleted";
export const BATCH_RETRY_REDEEM_REWARD_ERROR = "support/batchRetryRedeemRewardError";
export const FETCH_RETRY_REDEEM_JOB_STATUS = "support/fetchRetryRedeemJobStatus";

export const batchRetryRedeemReward = (payload = {}) => ({
  type: BATCH_RETRY_REDEEM_REWARD,
  payload,
});

export const fetchRetryRedeemJobStatus = (payload = {}) => ({
  type: FETCH_RETRY_REDEEM_JOB_STATUS,
  payload,
});

export const CLEAR_FAILED_REDEMPTIONS_STATE = "support/clearFailedRedemptionsState";

export const clearFailedRedemptionsState = (payload = {}) => ({
  type: CLEAR_FAILED_REDEMPTIONS_STATE,
  payload,
});

export const FETCH_MERGE_WALLET_DATA = "support/fetchMergeWalletData";
export const FETCH_MERGE_WALLET_DATA_START = "support/fetchMergeWalletDataStart";
export const FETCH_MERGE_WALLET_DATA_COMPLETE = "support/fetchMergeWalletDataCompleted";
export const FETCH_MERGE_WALLET_DATA_ERROR = "support/fetchMergeWalletDataError";

export const fetchMergeWalletData = (payload = {}) => ({
  type: FETCH_MERGE_WALLET_DATA,
  payload,
});

export const MERGE_WALLET = "support/mergeWallet";
export const MERGE_WALLET_START = "support/mergeWalletStart";
export const MERGE_WALLET_COMPLETE = "support/mergeWalletCompleted";
export const MERGE_WALLET_ERROR = "support/mergeWalletError";

export const mergeWallet = (payload = {}) => ({
  type: MERGE_WALLET,
  payload,
});

export const CLEAR_MERGE_WALLET_STATE = "support/clearMergeWalletState";

export const clearMergeWalletState = (payload = {}) => ({
  type: CLEAR_MERGE_WALLET_STATE,
  payload,
});

export const FETCH_CAREGIVER_BY_PHONE = "support/fetchCaregiverByPhone";
export const FETCH_CAREGIVER_BY_PHONE_START = "support/fetchCaregiverByPhoneStart";
export const FETCH_CAREGIVER_BY_PHONE_COMPLETE = "support/fetchCaregiverByPhoneCompleted";
export const FETCH_CAREGIVER_BY_PHONE_ERROR = "support/fetchCaregiverByPhoneError";

export const fetchCaregiverByPhone = (payload = {}) => ({
  type: FETCH_CAREGIVER_BY_PHONE,
  payload,
});

export const CHANGE_EMPLOYEE_PASSWORD = "support/changeEmployeePassword";
export const CHANGE_EMPLOYEE_PASSWORD_START = "support/changeEmployeePasswordStart";
export const CHANGE_EMPLOYEE_PASSWORD_COMPLETE = "support/changeEmployeePasswordCompleted";
export const CHANGE_EMPLOYEE_PASSWORD_ERROR = "support/changeEmployeePasswordError";

export const changeEmployeePassword = (payload = {}) => ({
  type: CHANGE_EMPLOYEE_PASSWORD,
  payload,
});

export const CLEAR_CHANGE_PASSWORD_STATE = "support/clearChangePasswordState";

export const clearChangePasswordState = (payload = {}) => ({
  type: CLEAR_CHANGE_PASSWORD_STATE,
  payload,
});

export const FETCH_REWARD_CONFIG_LIST = "support/fetchRewardConfigList";
export const FETCH_REWARD_CONFIG_LIST_START = "support/fetchRewardConfigListStart";
export const FETCH_REWARD_CONFIG_LIST_COMPLETE = "support/fetchRewardConfigListCompleted";
export const FETCH_REWARD_CONFIG_LIST_ERROR = "support/fetchRewardConfigListError";

export const fetchRewardConfigList = (payload = {}) => ({
  type: FETCH_REWARD_CONFIG_LIST,
  payload,
});

export const MANUAL_REDEMPTION = "support/manualRedemption";
export const MANUAL_REDEMPTION_START = "support/manualRedemptionStart";
export const MANUAL_REDEMPTION_COMPLETE = "support/manualRedemptionCompleted";
export const MANUAL_REDEMPTION_ERROR = "support/manualRedemptionError";

export const manualRedemption = (payload = {}) => ({
  type: MANUAL_REDEMPTION,
  payload,
});

export const CLEAR_MANUAL_REDEMPTION_STATE = "support/clearManualRedemptionState";

export const clearManualRedemptionState = (payload = {}) => ({
  type: CLEAR_MANUAL_REDEMPTION_STATE,
  payload,
});

export const UPDATE_PRIMARY_PHONE = "support/updatePrimaryPhone";
export const UPDATE_PRIMARY_PHONE_START = "support/updatePrimaryPhoneStart";
export const UPDATE_PRIMARY_PHONE_COMPLETE = "support/updatePrimaryPhoneCompleted";
export const UPDATE_PRIMARY_PHONE_ERROR = "support/updatePrimaryPhoneError";

export const updatePrimaryPhone = (payload = {}) => ({
  type: UPDATE_PRIMARY_PHONE,
  payload,
});

export const CLEAR_UPDATE_PRIMARY_PHONE_STATE = "support/clearUpdatePrimaryPhoneState";

export const clearUpdatePrimaryPhoneState = (payload = {}) => ({
  type: CLEAR_UPDATE_PRIMARY_PHONE_STATE,
  payload,
});

export const FETCH_TANGO_TOTAL_BALANCE = 'support/fetchTangoTotalBalance';
export const FETCH_TANGO_TOTAL_BALANCE_START = 'support/fetchTangoTotalBalanceStart';
export const FETCH_TANGO_TOTAL_BALANCE_COMPLETE = 'support/fetchTangoTotalBalanceCompleted';
export const FETCH_TANGO_TOTAL_BALANCE_ERROR = 'support/fetchTangoTotalBalanceError';

export const fetchTangoTotalBalance = (payload = {}) => ({
  type: FETCH_TANGO_TOTAL_BALANCE,
  payload,
});

